export default function home_videos() {
	
	$('.block-photos .photo-list').owlCarousel({
    items: 2,
    dotsEach: false,
    loop: true,
    nav: true,
    smartSpeed: 1000,
    mouseDrag: false,
    margin: 15,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>'],
    responsive: {
      768: {
        items: 3,
        margin: 30
      }
    }
  });
	
  $('.block-photos .photo-list .item').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    verticalFit: true,
  });
}